import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IResponsePersonalAccessToken } from 'entities/Auth'

export class PersonalAccessTokenRow extends RowBase<IResponsePersonalAccessToken> {
  constructor(origin: IResponsePersonalAccessToken) {
    super(origin)
    makeObservableRowBase(this)
  }

  get name() {
    return this.origin.name
  }

  get scopes() {
    return this.origin.scopes
  }

  get revoked() {
    return this.origin.revoked
  }

  get created_at() {
    return this.origin.created_at
  }

  get expires_at() {
    return this.origin.expires_at
  }
}
